// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Entry-module__root--iRutQ {
  gap: 16px;
  display: flex;
  flex-direction: column;
}

.Entry-module__ui-Entry--KaF__ + .Entry-module__ui-Entry--KaF__ {
  /* border-bottom: 8px solid #F1E9DE; */
  margin-top: 16px;
}

.Entry-module__ui-Entry-Main--IKlUI {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  border: 1px solid transparent;
  background: #FFFFFF;
}

.Entry-module__spacing-medium--LFRQV .Entry-module__ui-Entry-Main--IKlUI {
  padding: 20px;
}

.Entry-module__spacing-large--yGImU .Entry-module__ui-Entry-Main--IKlUI {
  padding: 32px;
}

.Entry-module__ui-Entry-Header--xUoqe {
  width: 100%;
}

.Entry-module__ui-Entry-Body--MYL9Y {
  white-space: pre-wrap;
  width: 100%;
  gap: 12px;
  flex: 1;
}

.Entry-module__ui-Entry-Footer--oySzm {
  display: block;
  width: 100%;
  text-align: right;
}

.Entry-module__ui-Entry-Extension--nxnqv {
  display: flex;
  gap: 4px;
  margin-left: 20px;
  /* background: #F7F2EC; */
}

.Entry-module__variant-subtle--nkjHF .Entry-module__ui-Entry-Main--IKlUI {
  background: #F7F2EC;
}

.Entry-module__variant-bare--YSHfd .Entry-module__ui-Entry-Main--IKlUI {
  background: transparent;
}

.Entry-module__line-none--Q7Mk1 .Entry-module__ui-Entry-Main--IKlUI {
  border-color: transparent;
}

.Entry-module__line-outline--YNVS2 .Entry-module__ui-Entry-Main--IKlUI {
  border-color: #DDD7CE;
}

.Entry-module__line-top--eS03s .Entry-module__ui-Entry-Main--IKlUI {
  border-top-color: #DDD7CE;
}

.Entry-module__is-reverse--gkvb6 {
  color: #ffffff;
}

.Entry-module__is-reverse--gkvb6 .Entry-module__ui-Entry-Main--IKlUI {
  background-color: transparent;
}

.Entry-module__is-reverse--gkvb6 .Entry-module__ui-Entry-Body--MYL9Y {
  color: #E2E2E2
} 

.Entry-module__is-reverse--gkvb6.Entry-module__line-outline--YNVS2 .Entry-module__ui-Entry-Main--IKlUI {
  border-color: rgba(255, 255, 255, 0.05);
}

.Entry-module__is-reverse--gkvb6.Entry-module__line-top--eS03s .Entry-module__ui-Entry-Main--IKlUI {
  border-top-color: rgba(255, 255, 255, 0.05);
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Entry/Entry.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,SAAS;EACT,OAAO;AACT;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;AACF;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C","sourcesContent":[".root {\n  gap: 16px;\n  display: flex;\n  flex-direction: column;\n}\n\n.ui-Entry + .ui-Entry {\n  /* border-bottom: 8px solid #F1E9DE; */\n  margin-top: 16px;\n}\n\n.ui-Entry-Main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: flex-start;\n  border: 1px solid transparent;\n  background: #FFFFFF;\n}\n\n.spacing-medium .ui-Entry-Main {\n  padding: 20px;\n}\n\n.spacing-large .ui-Entry-Main {\n  padding: 32px;\n}\n\n.ui-Entry-Header {\n  width: 100%;\n}\n\n.ui-Entry-Body {\n  white-space: pre-wrap;\n  width: 100%;\n  gap: 12px;\n  flex: 1;\n}\n\n.ui-Entry-Footer {\n  display: block;\n  width: 100%;\n  text-align: right;\n}\n\n.ui-Entry-Extension {\n  display: flex;\n  gap: 4px;\n  margin-left: 20px;\n  /* background: #F7F2EC; */\n}\n\n.variant-subtle .ui-Entry-Main {\n  background: #F7F2EC;\n}\n\n.variant-bare .ui-Entry-Main {\n  background: transparent;\n}\n\n.line-none .ui-Entry-Main {\n  border-color: transparent;\n}\n\n.line-outline .ui-Entry-Main {\n  border-color: #DDD7CE;\n}\n\n.line-top .ui-Entry-Main {\n  border-top-color: #DDD7CE;\n}\n\n.is-reverse {\n  color: #ffffff;\n}\n\n.is-reverse .ui-Entry-Main {\n  background-color: transparent;\n}\n\n.is-reverse .ui-Entry-Body {\n  color: #E2E2E2\n} \n\n.is-reverse.line-outline .ui-Entry-Main {\n  border-color: rgba(255, 255, 255, 0.05);\n}\n\n.is-reverse.line-top .ui-Entry-Main {\n  border-top-color: rgba(255, 255, 255, 0.05);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Entry-module__root--iRutQ`,
	"ui-Entry": `Entry-module__ui-Entry--KaF__`,
	"ui-Entry-Main": `Entry-module__ui-Entry-Main--IKlUI`,
	"spacing-medium": `Entry-module__spacing-medium--LFRQV`,
	"spacing-large": `Entry-module__spacing-large--yGImU`,
	"ui-Entry-Header": `Entry-module__ui-Entry-Header--xUoqe`,
	"ui-Entry-Body": `Entry-module__ui-Entry-Body--MYL9Y`,
	"ui-Entry-Footer": `Entry-module__ui-Entry-Footer--oySzm`,
	"ui-Entry-Extension": `Entry-module__ui-Entry-Extension--nxnqv`,
	"variant-subtle": `Entry-module__variant-subtle--nkjHF`,
	"variant-bare": `Entry-module__variant-bare--YSHfd`,
	"line-none": `Entry-module__line-none--Q7Mk1`,
	"line-outline": `Entry-module__line-outline--YNVS2`,
	"line-top": `Entry-module__line-top--eS03s`,
	"is-reverse": `Entry-module__is-reverse--gkvb6`
};
export default ___CSS_LOADER_EXPORT___;
